import React from 'react';
import { Row, Col } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

import RestInputItem from 'components/RestInput/RestInputItem';

const CompanyFilterForm = () => (
  <Row gutter={16}>
    <Col xl={8} md={12} xs={12}>
      <RestInputItem
        source={['filter', 'name', '$like']}
        placeholder="users.searchCompanyName"
        isShowTooltip
        inputProps={{ prefix: <SearchOutlined /> }}
      />
    </Col>
    <Col xl={16} md={12} xs={12}>
      <RestInputItem
        source="q"
        placeholder="input.searchProviderCentreCode"
        isShowTooltip
        inputProps={{ prefix: <SearchOutlined /> }}
      />
    </Col>
  </Row>
);

export default CompanyFilterForm;
